import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVault: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="vault, safe"><path d="M6.75 18.25H3.75V3.75H20.25V18.25H17.25M6.75 18.25V20.25M6.75 18.25H17.25M17.25 18.25V20.25M11.25 11H8M16.25 11C16.25 13.3472 14.3472 15.25 12 15.25C9.65279 15.25 7.75 13.3472 7.75 11C7.75 8.65279 9.65279 6.75 12 6.75C14.3472 6.75 16.25 8.65279 16.25 11Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVault;
